<template>
  <div class="travel-guide-list-container">
    <h1 class="page-title">旅游攻略列表</h1>
    <el-card class="content-card">
      <div class="card-header">
        <h2>旅游攻略列表</h2>
        <el-button type="primary" @click="handleAddGuide">
          <el-icon><plus /></el-icon> 添加旅游攻略
        </el-button>
      </div>
      <div class="card-content">
        <el-table :data="travelGuides" border stripe style="width: 100%" v-loading="loading">
          <el-table-column prop="id" label="ID" width="80" />
          <el-table-column label="封面图片" width="120">
            <template #default="scope">
              <el-image
                v-if="scope.row.cover_image"
                :src="scope.row.cover_image"
                :fit="'cover'"
                style="width: 100px; height: 60px;"
              />
              <span v-else>无图片</span>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="攻略名称" min-width="200" />
          <el-table-column prop="author" label="作者" width="120" />
          <el-table-column prop="status" label="状态" width="100">
            <template #default="scope">
              <el-tag :type="scope.row.status === true ? 'success' : 'danger'">
                {{ scope.row.status === true ? '启用' : '禁用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="sort_order" label="排序" width="100" />
          <el-table-column prop="created_at" label="创建时间" width="180" />
          <el-table-column label="操作" width="200" fixed="right">
            <template #default="scope">
              <el-button type="primary" size="small" @click="handleEditGuide(scope.row)">
                <el-icon><edit /></el-icon> 编辑
              </el-button>
              <el-button type="danger" size="small" @click="handleDeleteGuide(scope.row)">
                <el-icon><delete /></el-icon> 删除
              </el-button>
              <el-switch
                v-model="scope.row.status"
                @change="handleStatusChange(scope.row)"
                style="margin-left: 10px;"
              />
            </template>
          </el-table-column>
        </el-table>
        
        <div class="pagination-container">
          <el-pagination
            :current-page="pagination.currentPage"
            :page-size="pagination.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </el-card>
    
    <!-- 添加/编辑旅游攻略右侧抽屉 -->
    <el-drawer
      v-model="drawerVisible"
      :title="isEditMode ? '编辑旅游攻略' : '添加旅游攻略'"
      direction="rtl"
      size="800px"
      @close="resetForm"
    >
      <el-form :model="guideForm" :rules="guideRules" ref="guideFormRef" label-width="100px" style="padding: 0 20px;">
        <el-form-item label="攻略名称" prop="title">
          <el-input v-model="guideForm.title" placeholder="请输入攻略名称" />
        </el-form-item>
        <el-form-item label="作者" prop="author">
          <el-input v-model="guideForm.author" placeholder="请输入作者" />
        </el-form-item>
        <el-form-item label="封面图片" prop="cover_image">
          <el-upload
            :file-list="coverFileList"
            :action="`${apiBaseUrl}/manage/upload/image`"
            list-type="picture-card"
            :auto-upload="true"
            :on-preview="handleCoverPreview"
            :on-remove="handleCoverRemove"
            :on-success="handleCoverUploadSuccess"
            :before-upload="beforeImageUpload"
            :data="{ type: 'travel_guide' }"
            :headers="{ 'Authorization': `Bearer ${authToken}` }"
          >
            <el-icon><plus /></el-icon>
            <template #tip>
              <div class="el-upload__tip">
                只能上传jpg/png文件，且不超过20MB
              </div>
            </template>
          </el-upload>
          <el-dialog v-model="previewVisible" title="预览图片">
            <img style="width: 100%" :src="dialogImageUrl" alt="预览图片" />
          </el-dialog>
        </el-form-item>
        <el-form-item label="轮播图片" prop="carousel_images">
          <el-upload
            :file-list="carouselFileList"
            action="http://127.0.0.1:8000/api/manage/upload/image"
            list-type="picture-card"
            :auto-upload="true"
            :on-preview="handleCarouselPreview"
            :on-remove="handleCarouselRemove"
            :on-success="handleCarouselUploadSuccess"
            :before-upload="beforeImageUpload"
            :data="{ type: 'travel_guide' }"
            :headers="{ 'Authorization': `Bearer ${authToken}` }"
            multiple
          >
            <el-icon><plus /></el-icon>
            <template #tip>
              <div class="el-upload__tip">
                只能上传jpg/png文件，且不超过20MB，最多上传5张
              </div>
            </template>
          </el-upload>
        </el-form-item>
        <el-form-item label="攻略描述" prop="description">
          <el-input v-model="guideForm.description" type="textarea" placeholder="请输入攻略描述" rows="3" />
        </el-form-item>
        <el-form-item label="攻略内容" prop="content">
          <el-input v-model="guideForm.content" type="textarea" placeholder="请输入攻略内容" rows="10" />
        </el-form-item>
        <el-form-item label="关联门店" prop="store_ids">
          <el-select
            v-model="guideForm.store_ids"
            placeholder="请选择关联门店"
            multiple
            filterable
            clearable
            style="width: 100%"
          >
            <el-option
              v-for="store in stores"
              :key="store.id"
              :label="store.name"
              :value="store.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="排序" prop="sort_order">
          <el-input-number v-model="guideForm.sort_order" :min="0" :max="999" placeholder="请输入排序号" style="width: 100%" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-switch v-model="guideForm.status" />
        </el-form-item>
        <div class="drawer-footer" style="margin-top: 20px; text-align: right;">
          <el-button @click="drawerVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSubmitForm">确定</el-button>
        </div>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { Plus, Edit, Delete } from '@element-plus/icons-vue';
import request from '../../api/axios';

export default {
  name: 'TravelGuideList',
  components: {
    Plus,
    Edit,
    Delete
  },
  setup() {
    // 获取API基础URL，与axios配置保持一致
    const apiBaseUrl = ref(process.env.VUE_APP_API_BASE_URL || 'http://127.0.0.1:8000/api');
    
    const travelGuides = ref([]);
    const loading = ref(false);
    const stores = ref([]);
    const drawerVisible = ref(false);
    const isEditMode = ref(false);
    const guideFormRef = ref(null);
    
    // 图片上传相关变量
    const coverFileList = ref([]);
    const carouselFileList = ref([]);
    const previewVisible = ref(false);
    const dialogImageUrl = ref('');
    const authToken = ref(localStorage.getItem('token') || '');
    
    const pagination = ref({
      currentPage: 1,
      pageSize: 10,
      total: 0
    });
    
    const guideForm = ref({
      title: '',
      author: '',
      cover_image: '',
      carousel_images: '',
      description: '',
      content: '',
      store_ids: [],
      sort_order: 0,
      status: true
    });
    
    const guideRules = {
      title: [
        { required: true, message: '请输入攻略名称', trigger: 'blur' }
      ],
      cover_image: [
        { required: true, message: '请上传封面图片', trigger: 'blur' }
      ],
      content: [
        { required: true, message: '请输入攻略内容', trigger: 'blur' }
      ]
    };
    
    // 获取旅游攻略列表
    const fetchTravelGuides = async () => {
      loading.value = true;
      try {
        const response = await request({
          url: '/manage/travel-guides',
          method: 'get',
          params: {
            page: pagination.value.currentPage,
            page_size: pagination.value.pageSize
          }
        });
        // 确保travelGuides.value始终是数组类型
        travelGuides.value = response.data?.list || [];
        pagination.value.total = response.data?.total || 0;
      } catch (error) {
        ElMessage.error('获取旅游攻略列表失败');
        console.error(error);
        // 发生错误时，确保travelGuides.value是数组
        travelGuides.value = [];
        pagination.value.total = 0;
      } finally {
        loading.value = false;
      }
    };
    
    // 获取门店列表
    const fetchStores = async () => {
      try {
        const response = await request({
          url: '/manage/stores',
          method: 'get'
        });
        stores.value = response.data.data;
      } catch (error) {
        ElMessage.error('获取门店列表失败');
        console.error(error);
      }
    };
    
    // 页面加载时获取数据
    onMounted(() => {
      fetchTravelGuides();
      fetchStores();
    });
    
    // 图片上传前的验证
    const beforeImageUpload = (file) => {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt20M = file.size / 1024 / 1024 < 20;
      
      if (!isJPG) {
        ElMessage.error('只能上传JPG/PNG格式的图片');
      }
      if (!isLt20M) {
        ElMessage.error('图片大小不能超过20MB');
      }
      
      return isJPG && isLt20M;
    };
    
    // 封面图片预览
    const handleCoverPreview = (file) => {
      dialogImageUrl.value = file.url;
      previewVisible.value = true;
    };
    
    // 封面图片移除
    const handleCoverRemove = () => {
      coverFileList.value = [];
      guideForm.value.cover_image = '';
    };
    
    // 封面图片上传成功
    const handleCoverUploadSuccess = (response, file) => {
      try {
        console.log('=== 封面图片上传响应开始 ===');
        console.log('原始响应对象:', response);
        console.log('响应JSON:', JSON.stringify(response, null, 2));
        console.log('文件对象:', file);
        
        // 处理不同的响应格式
        let imgUrl = '';
        let matchedFormat = '未匹配';
        
        // 检查响应格式
        if (response && response.errno === 0 && response.data && Array.isArray(response.data) && response.data.length > 0) {
          // 格式1: { errno: 0, data: [{ url: 'xxx' }] }
          if (response.data[0] && response.data[0].url) {
            imgUrl = response.data[0].url;
            matchedFormat = '格式1';
            console.log('匹配格式1，获取到图片URL:', imgUrl);
          }
        } else if (response && response.code === 0 && response.data && response.data.url) {
          // 格式2: { code: 0, data: { url: 'xxx' } }
          imgUrl = response.data.url;
          matchedFormat = '格式2';
          console.log('匹配格式2，获取到图片URL:', imgUrl);
        } else if (response && response.url) {
          // 格式3: { url: 'xxx' }
          imgUrl = response.url;
          matchedFormat = '格式3';
          console.log('匹配格式3，获取到图片URL:', imgUrl);
        } else if (response && response.data && typeof response.data === 'string') {
          // 格式4: { data: 'xxx' }
          imgUrl = response.data;
          matchedFormat = '格式4';
          console.log('匹配格式4，获取到图片URL:', imgUrl);
        } else if (response && response.data && response.data.url) {
          // 格式5: { data: { url: 'xxx' } }
          imgUrl = response.data.url;
          matchedFormat = '格式5';
          console.log('匹配格式5，获取到图片URL:', imgUrl);
        } else if (response && response.data && Array.isArray(response.data) && response.data.length > 0 && response.data[0].url) {
          // 格式6: { data: [{ url: 'xxx' }] }
          imgUrl = response.data[0].url;
          matchedFormat = '格式6';
          console.log('匹配格式6，获取到图片URL:', imgUrl);
        } else {
          console.error('无法匹配任何响应格式');
          console.error('响应结构分析:', {
            hasResponse: !!response,
            hasErrno: response && 'errno' in response,
            errnoValue: response && response.errno,
            hasData: response && 'data' in response,
            dataType: response && typeof response.data,
            isDataArray: response && Array.isArray(response.data),
            dataLength: response && Array.isArray(response.data) ? response.data.length : 'N/A',
            hasUrlInFirstItem: response && Array.isArray(response.data) && response.data.length > 0 && 'url' in response.data[0]
          });
          // 尝试直接从响应中提取URL
          if (typeof response === 'string') {
            imgUrl = response;
            matchedFormat = '直接字符串';
            console.log('直接将响应作为URL:', imgUrl);
          } else {
            // 最后尝试：遍历响应对象，查找URL字段
            const findUrl = (obj) => {
              if (typeof obj === 'string' && (obj.startsWith('http://') || obj.startsWith('https://') || obj.startsWith('/'))) {
                return obj;
              }
              if (typeof obj === 'object' && obj !== null) {
                for (const key in obj) {
                  const value = obj[key];
                  const result = findUrl(value);
                  if (result) return result;
                }
              }
              return null;
            };
            imgUrl = findUrl(response);
            matchedFormat = '遍历查找';
            console.log('通过遍历查找URL:', imgUrl);
          }
        }
        
        console.log('=== URL处理开始 ===');
        console.log('匹配格式:', matchedFormat);
        console.log('处理前的URL:', imgUrl);
        
        if (imgUrl) {
          // 确保返回的是完整的图片URL
          if (!imgUrl.startsWith('http://') && !imgUrl.startsWith('https://')) {
            console.log('URL不是完整地址，需要补全');
            // 如果URL没有前导斜杠，添加一个
            if (!imgUrl.startsWith('/')) {
              console.log('URL没有前导斜杠，添加');
              imgUrl = `/${imgUrl}`;
            }
            imgUrl = `${window.location.origin}${imgUrl}`;
            console.log('补全后的完整URL:', imgUrl);
          } else {
            console.log('URL已经是完整地址');
          }
          
          console.log('=== 更新表单数据开始 ===');
          console.log('更新guideForm.cover_image为:', imgUrl);
          guideForm.value.cover_image = imgUrl;
          console.log('更新coverFileList为:', [{ url: imgUrl, name: file.name || '封面图片', status: 'success' }]);
          coverFileList.value = [{ url: imgUrl, name: file.name || '封面图片', status: 'success' }];
          console.log('表单数据更新完成');
          
          ElMessage.success('封面图片上传成功');
          console.log('=== 封面图片上传处理完成 ===');
        } else {
          console.error('=== 错误：没有获取到有效的URL ===');
          throw new Error('Invalid response format: No URL found');
        }
      } catch (error) {
        console.error('=== 封面图片上传处理异常 ===');
        console.error('错误类型:', error.name);
        console.error('错误信息:', error.message);
        console.error('错误堆栈:', error.stack);
        console.error('响应详情:', JSON.stringify(response, null, 2));
        ElMessage.error('封面图片上传成功，但处理失败');
      }
    };
    
    // 轮播图片预览
    const handleCarouselPreview = (file) => {
      dialogImageUrl.value = file.url;
      previewVisible.value = true;
    };
    
    // 轮播图片移除
    const handleCarouselRemove = (file) => {
      // 更新轮播图片列表
      carouselFileList.value = carouselFileList.value.filter(item => item.url !== file.url);
      // 更新表单数据
      updateCarouselImages();
    };
    
    // 轮播图片上传成功
    const handleCarouselUploadSuccess = (response, file) => {
      try {
        console.log('=== 轮播图片上传响应开始 ===');
        console.log('原始响应对象:', response);
        console.log('响应JSON:', JSON.stringify(response, null, 2));
        console.log('文件对象:', file);
        
        // 处理不同的响应格式
        let imgUrl = '';
        let matchedFormat = '未匹配';
        
        // 检查响应格式
        if (response && response.errno === 0 && response.data && Array.isArray(response.data) && response.data.length > 0) {
          // 格式1: { errno: 0, data: [{ url: 'xxx' }] }
          if (response.data[0] && response.data[0].url) {
            imgUrl = response.data[0].url;
            matchedFormat = '格式1';
            console.log('匹配格式1，获取到图片URL:', imgUrl);
          }
        } else if (response && response.code === 0 && response.data && response.data.url) {
          // 格式2: { code: 0, data: { url: 'xxx' } }
          imgUrl = response.data.url;
          matchedFormat = '格式2';
          console.log('匹配格式2，获取到图片URL:', imgUrl);
        } else if (response && response.url) {
          // 格式3: { url: 'xxx' }
          imgUrl = response.url;
          matchedFormat = '格式3';
          console.log('匹配格式3，获取到图片URL:', imgUrl);
        } else if (response && response.data && typeof response.data === 'string') {
          // 格式4: { data: 'xxx' }
          imgUrl = response.data;
          matchedFormat = '格式4';
          console.log('匹配格式4，获取到图片URL:', imgUrl);
        } else if (response && response.data && response.data.url) {
          // 格式5: { data: { url: 'xxx' } }
          imgUrl = response.data.url;
          matchedFormat = '格式5';
          console.log('匹配格式5，获取到图片URL:', imgUrl);
        } else if (response && response.data && Array.isArray(response.data) && response.data.length > 0 && response.data[0].url) {
          // 格式6: { data: [{ url: 'xxx' }] }
          imgUrl = response.data[0].url;
          matchedFormat = '格式6';
          console.log('匹配格式6，获取到图片URL:', imgUrl);
        } else {
          console.error('无法匹配任何响应格式');
          console.error('响应结构分析:', {
            hasResponse: !!response,
            hasErrno: response && 'errno' in response,
            errnoValue: response && response.errno,
            hasData: response && 'data' in response,
            dataType: response && typeof response.data,
            isDataArray: response && Array.isArray(response.data),
            dataLength: response && Array.isArray(response.data) ? response.data.length : 'N/A',
            hasUrlInFirstItem: response && Array.isArray(response.data) && response.data.length > 0 && 'url' in response.data[0]
          });
          // 尝试直接从响应中提取URL
          if (typeof response === 'string') {
            imgUrl = response;
            matchedFormat = '直接字符串';
            console.log('直接将响应作为URL:', imgUrl);
          } else {
            // 最后尝试：遍历响应对象，查找URL字段
            const findUrl = (obj) => {
              if (typeof obj === 'string' && (obj.startsWith('http://') || obj.startsWith('https://') || obj.startsWith('/'))) {
                return obj;
              }
              if (typeof obj === 'object' && obj !== null) {
                for (const key in obj) {
                  const value = obj[key];
                  const result = findUrl(value);
                  if (result) return result;
                }
              }
              return null;
            };
            imgUrl = findUrl(response);
            matchedFormat = '遍历查找';
            console.log('通过遍历查找URL:', imgUrl);
          }
        }
        
        console.log('=== URL处理开始 ===');
        console.log('匹配格式:', matchedFormat);
        console.log('处理前的URL:', imgUrl);
        
        if (imgUrl) {
          // 确保返回的是完整的图片URL
          if (!imgUrl.startsWith('http://') && !imgUrl.startsWith('https://')) {
            console.log('URL不是完整地址，需要补全');
            // 如果URL没有前导斜杠，添加一个
            if (!imgUrl.startsWith('/')) {
              console.log('URL没有前导斜杠，添加');
              imgUrl = `/${imgUrl}`;
            }
            imgUrl = `http://127.0.0.1:8000${imgUrl}`;
            console.log('补全后的完整URL:', imgUrl);
          } else {
            console.log('URL已经是完整地址');
          }
          
          // 检查图片是否已存在
          console.log('=== 检查图片是否已存在 ===');
          const existingIndex = carouselFileList.value.findIndex(item => item.url === imgUrl);
          console.log('现有图片列表长度:', carouselFileList.value.length);
          console.log('是否已存在:', existingIndex !== -1);
          
          if (existingIndex === -1) {
            // 添加到轮播图片列表
            console.log('=== 添加到轮播图片列表 ===');
            const newImageItem = { 
              url: imgUrl, 
              name: file.name || `轮播图${carouselFileList.value.length + 1}`, 
              status: 'success' 
            };
            console.log('添加的图片项:', newImageItem);
            carouselFileList.value.push(newImageItem);
            console.log('添加后图片列表长度:', carouselFileList.value.length);
            
            // 更新表单数据
            console.log('=== 更新轮播图片表单数据 ===');
            updateCarouselImages();
            console.log('表单数据更新完成');
            
            ElMessage.success('轮播图片上传成功');
          } else {
            console.log('图片已存在，跳过添加');
            ElMessage.success('轮播图片上传成功（已存在）');
          }
          
          console.log('=== 轮播图片上传处理完成 ===');
        } else {
          console.error('=== 错误：没有获取到有效的URL ===');
          throw new Error('Invalid response format: No URL found');
        }
      } catch (error) {
        console.error('=== 轮播图片上传处理异常 ===');
        console.error('错误类型:', error.name);
        console.error('错误信息:', error.message);
        console.error('错误堆栈:', error.stack);
        console.error('响应详情:', JSON.stringify(response, null, 2));
        ElMessage.error('轮播图片上传成功，但处理失败');
      }
    };
    
    // 更新轮播图片表单数据
    const updateCarouselImages = () => {
      const carouselImages = carouselFileList.value.map(item => item.url);
      guideForm.value.carousel_images = JSON.stringify(carouselImages);
    };
    
    // 打开添加旅游攻略抽屉
    const handleAddGuide = () => {
      isEditMode.value = false;
      resetForm();
      drawerVisible.value = true;
    };
    
    // 打开编辑旅游攻略抽屉
    const handleEditGuide = (guide) => {
      isEditMode.value = true;
      guideForm.value = { ...guide };
      
      // 初始化封面图片列表
      if (guide.cover_image) {
        coverFileList.value = [{ url: guide.cover_image, name: '封面图片', status: 'success' }];
      } else {
        coverFileList.value = [];
      }
      
      // 初始化轮播图片列表
      carouselFileList.value = [];
      if (guide.carousel_images) {
        try {
          const carouselImages = JSON.parse(guide.carousel_images);
          if (Array.isArray(carouselImages)) {
            carouselFileList.value = carouselImages.map((url, index) => ({
              url,
              name: `轮播图${index + 1}`,
              status: 'success'
            }));
          }
        } catch (error) {
          console.error('解析轮播图片失败:', error);
        }
      }
      
      drawerVisible.value = true;
    };
    
    // 关闭抽屉时重置表单
    const resetForm = () => {
      guideForm.value = {
        title: '',
        author: '',
        cover_image: '',
        carousel_images: '',
        description: '',
        content: '',
        store_ids: [],
        sort_order: 0,
        status: true
      };
      coverFileList.value = [];
      carouselFileList.value = [];
      if (guideFormRef.value) {
        guideFormRef.value.resetFields();
      }
    };
    
    // 提交表单
    const handleSubmitForm = async () => {
      if (!guideFormRef.value) return;
      
      await guideFormRef.value.validate(async (valid) => {
        if (valid) {
          try {
            if (isEditMode.value) {
              // 更新旅游攻略
              await request({
                url: `/manage/travel-guides/${guideForm.value.id}`,
                method: 'put',
                data: guideForm.value
              });
              ElMessage.success('更新成功');
            } else {
              // 创建旅游攻略
              await request({
                url: '/manage/travel-guides',
                method: 'post',
                data: guideForm.value
              });
              ElMessage.success('创建成功');
            }
            drawerVisible.value = false;
            fetchTravelGuides();
          } catch (error) {
            ElMessage.error(isEditMode.value ? '更新失败' : '创建失败');
            console.error(error);
          }
        } else {
          return false;
        }
      });
    };
    
    // 删除旅游攻略
    const handleDeleteGuide = (guide) => {
      ElMessageBox.confirm('确定要删除该旅游攻略吗？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await request({
            url: `/manage/travel-guides/${guide.id}`,
            method: 'delete'
          });
          ElMessage.success('删除成功');
          fetchTravelGuides();
        } catch (error) {
          ElMessage.error('删除失败');
          console.error(error);
        }
      }).catch(() => {
        // 取消删除操作
      });
    };
    
    // 切换旅游攻略状态
    const handleStatusChange = async (guide) => {
      try {
        await request({
          url: `/manage/travel-guides/${guide.id}`,
          method: 'put',
          data: {
            status: guide.status
          }
        });
        ElMessage.success('状态更新成功');
      } catch (error) {
        ElMessage.error('状态更新失败');
        // 恢复原状态
        guide.status = !guide.status;
        console.error(error);
      }
    };
    
    // 处理分页大小变化
    const handleSizeChange = (size) => {
      pagination.value.pageSize = size;
      fetchTravelGuides();
    };
    
    // 处理当前页变化
    const handleCurrentChange = (current) => {
      pagination.value.currentPage = current;
      fetchTravelGuides();
    };
    
    return {
      apiBaseUrl,
      travelGuides,
      loading,
      stores,
      drawerVisible,
      isEditMode,
      guideFormRef,
      pagination,
      guideForm,
      guideRules,
      coverFileList,
      carouselFileList,
      previewVisible,
      dialogImageUrl,
      authToken,
      handleAddGuide,
      handleEditGuide,
      resetForm,
      handleSubmitForm,
      handleDeleteGuide,
      handleStatusChange,
      handleSizeChange,
      handleCurrentChange,
      beforeImageUpload,
      handleCoverPreview,
      handleCoverRemove,
      handleCoverUploadSuccess,
      handleCarouselPreview,
      handleCarouselRemove,
      handleCarouselUploadSuccess
    };
  }
};
</script>

<style scoped>
.travel-guide-list-container {
  padding: 20px;
}

.page-title {
  font-size: 24px;
  margin-bottom: 20px;
  color: #333;
}

.content-card {
  margin-bottom: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.card-header h2 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.card-content {
  padding: 0;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
</style>